module.exports = __webpack_public_path__ + "media/images/kebab_menu_icon-4def5f5a546102d60019b9c2dedcc0a3.svg";